export {default} from './RankPerformanceSection.connect';
